<template>
    <div class="grid grid-cols-12 base-responsive-gap" style="grid-template-rows: auto 1fr">
        <div class="col-span-12 sm:col-span-6 lg:col-start-6 separator-border-top-line">
            <h2 class="header-3 mb-4"><T :t="title1Key" /></h2>
            <p><T :t="description1Key" /></p>
        </div>

        <div class="col-span-12 sm:col-span-6 lg:col-span-4 lg:col-start-2 md:row-span-2 lg:row-start-1">
            <StaticImage
                :img-key="staticImageKey"
                wrapper-class="aspect-w-2 aspect-h-3 relative base-responsive-rounding"
                image-class="w-full h-full object-cover "
            />
        </div>

        <div class="col-span-12 md:col-span-6 lg:col-span-6">
            <h2 class="header-3 mb-4"><T :t="title2Key" /></h2>
            <p><T :t="description2Key" /></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type10Block',
    props: {
        title1Key: {
            type: String,
            required: true,
        },
        description1Key: {
            type: String,
            required: true,
        },
        title2Key: {
            type: String,
            required: true,
        },
        description2Key: {
            type: String,
            required: true,
        },
        staticImageKey: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped></style>
